import React from "react";
import ReactDOM from "react-dom/client";
// Bootstrap's CSS, from the installed package rather than the CDN <link> that
// public/index.html used to carry. That tag was pinned to 5.3.3 while
// package.json installed 5.3.8, so the stylesheet the browser loaded and the
// one the lockfile tracked were different releases and nothing could see the
// gap — npm never saw the tag, and `bootstrap` looked like an unused dependency
// because nothing imported it. Only utility classes are used here (d-flex,
// justify-content-*, gap-2, w-100, mt-5, btn btn-primary); the JS bundle that
// sat at the end of <body> is gone, because src/ has zero data-bs-* attributes.
//
// Imported FIRST, before ./index.css, so app styles still win the cascade the
// way they did when the <link> was in <head>.
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { UserProvider } from 'context/AdminContext';
import { ThemeProvider } from "@emotion/react";
import customTheme from 'config/theme';
import { ToastContainer } from "react-toastify";
import { initRum } from "./observability/rum";
import ErrorBoundary from "./observability/ErrorBoundary";
import RumRouteTracker from "./observability/RumRouteTracker";
import { APP_VERSION, GIT_SHA } from "config/env";

// Build stamp injected by the deploy workflows (see GIT_WORKFLOW.md → Versioning);
// values are absent in local dev.
console.info(
  `admin-frontend ${APP_VERSION || "dev"} ` +
    `(${(GIT_SHA || "local").slice(0, 8)})`
);

// CloudWatch RUM (no-op unless the app monitor env vars are baked in).
// See root FRONTEND_RUM_SETUP.md.
initRum();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <RumRouteTracker />
      <UserProvider>
        <ThemeProvider theme={customTheme}>
          <App />
          <ToastContainer />
        </ThemeProvider>
      </UserProvider>
    </BrowserRouter>
  </ErrorBoundary>
);
